var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContentPrev = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 6,
  height: 10,
  viewBox: "0 0 6 10",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m0 5 5.263-5L6 .7 1.474 5 6 9.3l-.737.7z",
  fill: "#FFF",
  fillRule: "evenodd"
})));
export { SvgContentPrev as ReactComponent };
export default __webpack_public_path__ + "assets/images/content-prev.svg";